import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { NgxsModule } from '@ngxs/store';
import { ConsoleToggleComponent } from './console-toggle.component';
import { ConsoleState } from './console/state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
let ConsoleFrontendSharedFeature = /*#__PURE__*/(() => {
  let ConsoleFrontendSharedFeature = class ConsoleFrontendSharedFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/console/frontend-shared","featureId":"common-console"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: ConsoleToggleComponent,
        excludeSSR: true
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵConsoleFrontendSharedFeature_BaseFactory;
        return function ConsoleFrontendSharedFeature_Factory(__ngFactoryType__) {
          return (ɵConsoleFrontendSharedFeature_BaseFactory || (ɵConsoleFrontendSharedFeature_BaseFactory = i0.ɵɵgetInheritedFactory(ConsoleFrontendSharedFeature)))(__ngFactoryType__ || ConsoleFrontendSharedFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: ConsoleFrontendSharedFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, NgxsModule.forFeature([ConsoleState])]
      });
    }
  };
  ConsoleFrontendSharedFeature = __decorate([ClassName('ConsoleFrontendSharedFeature')], ConsoleFrontendSharedFeature);
  return ConsoleFrontendSharedFeature;
})();
export { ConsoleFrontendSharedFeature };